export enum IntegrationsSortByOption {
  POPULARITY = 'popularity',
  ASCENDING = 'az',
  DESCENDING = 'za',
}

export const sortByLabels = {
  [IntegrationsSortByOption.POPULARITY]: 'Popularity',
  [IntegrationsSortByOption.ASCENDING]: 'A-Z',
  [IntegrationsSortByOption.DESCENDING]: 'Z-A',
};

export enum IntegrationsCategoryOption {
  ALL = 'all',
  EXCHANGES = 'exchanges',
  WALLETS = 'wallets',
  BLOCKCHAINS = 'blockchains',
}

export const categoryLabels = {
  [IntegrationsCategoryOption.ALL]: 'All integrations',
  [IntegrationsCategoryOption.EXCHANGES]: 'Exchanges',
  [IntegrationsCategoryOption.WALLETS]: 'Wallets',
  [IntegrationsCategoryOption.BLOCKCHAINS]: 'Blockchains',
};

export interface IntegrationsFilter {
  sortBy: IntegrationsSortByOption;
  category: IntegrationsCategoryOption;
  autoSync: boolean;
  customFile: boolean;
  csv: boolean;
}
